// ContactUsA.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin/** , Send, Clock, Users */ } from 'lucide-react';

export default function ContactUsA() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you! We will get back to you.');
    setFormData({name:'', email:'', subject:'', message:''});
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold text-gray-800">Contact Us</h1>

      <div className="grid lg:grid-cols-2 gap-8">
        {/* Contact Info Card */}
        <div className="space-y-6">
          <div className="p-6 bg-white rounded-2xl shadow space-y-4">
            <h2 className="text-xl font-semibold">Contact Information</h2>

            <div className="flex items-start space-x-3">
              <Mail size={24} className="text-blue-600 mt-1" />
              <div>
                <p className="text-gray-600">themaseiduedufund@gmail.com</p>
              </div>
            </div>

            <div className="flex items-start space-x-3">
              <Phone size={24} className="text-green-600 mt-1" />
              <div>
                <p className="text-gray-600"> +233551605410/ +233202683143/ +233208785404</p>
              </div>
            </div>

            <div className="flex items-start space-x-7">
              <MapPin size={24} className="text-purple-600 mt-1" />
              <div className='flex flex-start flex-col'>
                <ul className='list-disc flex flex-col text-start'>
                    <li className='disc'><p className="text-gray-600">Bomandi International School c/o P. O. Box 181 Tiegberi, Wa Upper West Region</p></li>
                    <li> <p className="text-gray-600">Suglo & Associates P. O. Box GP 18097 Diamond House, 3rd Floor Accra - Ghana</p></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Optional Office Hours 
          <div className="p-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl text-white">
            <div className="flex items-center space-x-4">
              <Clock size={24} />
              <div>
                <h4 className="font-semibold">Office Hours</h4>
                <p>Mon-Fri: 9AM - 5PM</p>
              </div>
            </div>
          </div>
          */}
        </div>

        {/* Contact Form */}
        <motion.form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-2xl shadow space-y-4"
        >
          <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
            <label className="md:w-1/4 font-medium">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              className="w-full md:flex-1 border p-2 rounded-md"
              required
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
            <label className="md:w-1/4 font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full md:flex-1 border p-2 rounded-md"
              required
            />
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
            <label className="md:w-1/4 font-medium">Subject</label>
            <select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="w-full md:flex-1 border p-2 rounded-md"
              required
            >
              <option value="">Select a subject</option>
              <option value="scholarship">Scholarship Inquiry</option>
              <option value="partnership">Partnership Opportunity</option>
              <option value="donation">Donation</option>
              <option value="volunteer">Volunteer</option>
              <option value="general">General Inquiry</option>
            </select>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
            <label className="md:w-1/4 font-medium">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write your message..."
              rows={4}
              className="w-full md:flex-1 border p-2 rounded-md"
              required
            />
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
          >
            Send Message
          </button>
        </motion.form>
      </div>
    </div>
  );
}
